import React from "react";

const ProjectChart = ({ title, percentage, color, dimesioning }) => {
  const radius = 60;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className="flex flex-col items-center bg-white">
      <div className="relative">
        <svg width="150" height="150">
          <circle
            stroke={dimesioning}
            strokeWidth="28"
            fill="transparent"
            r={radius}
            cx="75"
            cy="75"
          />
          <circle
            stroke={color}
            strokeWidth="28"
            fill="transparent"
            r={radius}
            cx="75"
            cy="75"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-2xl font-semibold text-slate-800">
            {percentage}%
          </span>
        </div>
      </div>
      <p className="text-center text-slate-600 text-sm font-medium mt-3">
        {title}
      </p>
    </div>
  );
};

export default ProjectChart;
